<template>
  <div>
    <v-btn @click="open()" class="white--text" color="green" rounded>
      <v-icon class="mr-1">mdi-cash-register</v-icon>
      List of Sales</v-btn
    >
    <v-dialog v-model="dialog" persistent width="750">
      <v-card>
        <ModalHeader
          title="List of Sales"
          icon="mdi-printer"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <!-- Per Month Invoiced -->
          <h3>Per Month Invoiced Sales</h3>
          <p>Invoiced Sales</p>
          <div class="d-flex">
            <v-select
              outlined
              dense
              :items="months"
              item-text="text"
              item-value="value"
              label="Month"
              v-model="printForm.month"
              class="mr-3"
              prepend-inner-icon="mdi-calendar"
            ></v-select>
            <v-select
              outlined
              dense
              :items="[2024, 2025, 2026, 2027]"
              item-text="text"
              item-value="value"
              label="Year"
              v-model="printForm.year"
              class="mr-3"
              prepend-inner-icon="mdi-calendar"
            ></v-select>

            <v-btn
              class="mt-3"
              small
              color="primary"
              @click="printSale('perMonthInvoice')"
              >Print</v-btn
            >
          </div>
          <!-- Per Month -->
          <h3>Per Month Cash Sales</h3>
          <p>Payments received from invoiced sales</p>
          <div class="d-flex">
            <v-select
              outlined
              dense
              :items="months"
              item-text="text"
              item-value="value"
              label="Month"
              v-model="printForm.month"
              class="mr-3"
              prepend-inner-icon="mdi-calendar"
            ></v-select>
            <v-select
              outlined
              dense
              :items="[2024, 2025, 2026, 2027]"
              item-text="text"
              item-value="value"
              label="Year"
              v-model="printForm.year"
              class="mr-3"
              prepend-inner-icon="mdi-calendar"
            ></v-select>

            <v-btn
              class="mt-3"
              small
              color="primary"
              @click="printSale('perMonth')"
              >Print</v-btn
            >
          </div>
          <!-- Per Day -->
          <h3>Print per day</h3>
          <p>Payments received from invoiced sales</p>
          <div class="d-flex">
            <v-select
              outlined
              dense
              :items="days"
              label="Day"
              v-model="printForm.day"
              class="mr-3"
              prepend-icon="mdi-calendar"
            ></v-select>
            <v-select
              outlined
              dense
              :items="months"
              item-text="text"
              item-value="value"
              label="Month"
              v-model="printForm.month"
              class="mr-3"
              prepend-inner-icon="mdi-calendar"
            ></v-select>
            <v-select
              outlined
              dense
              :items="[2024, 2025, 2026, 2027]"
              item-text="text"
              item-value="value"
              label="Year"
              v-model="printForm.year"
              class="mr-3"
              prepend-inner-icon="mdi-calendar"
            ></v-select>
            <v-btn
              class="mt-3"
              small
              color="primary"
              @click="printSale('perDay')"
              >Print</v-btn
            >
          </div>
          <!-- Per Batch -->
          <h3>Print Batch Sales</h3>
          <p>Invoiced items from specific Import Batches</p>
          <div class="d-flex">
            <v-select
              outlined
              dense
              label="Batch Import"
              :items="import_batches"
              item-text="batch_description"
              item-value="id"
              v-model="form.import_batch_id"
            ></v-select>

            <v-btn color="primary" @click="submit" :loading="loading" small
              >Print</v-btn
            >
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">printSalesSummaryModal.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import moment from "moment";
export default {
  // components: { CustomDatePicker },
  data() {
    return {
      perMonthItemsSelection: ["Item Sales", "Service Revenue", "All"],
      printForm: {
        day: 0,
        month: 0,
        year: 2024,
        selection: "Item Sales",
      },
      days: [],
      months: [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
      ],
      dialog: false,
      loading: false,
      form: {
        radioSelection: "items",
        fromDate: "",
        toDate: "",
        import_batch_id: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      import_batches: "importBatch/import_batches",
      default_server_url: "auth/default_server_url",
      user: "auth/user",
      hasPermission: "permission/hasPermission",
      user_permissions: "permission/user_permissions",
    }),
  },
  methods: {
    // Hat-based permission gate; accounts without hats get no access.
    can(key) {
      return this.hasPermission(key);
    },
    open() {
      if (!this.can("accounting.print_sales_summary")) {
        this.$alert({
          title: "Validation",
          message: "You are not allowed to access this feature",
          color: "warning",
          icon: "mdi-alert",
        });
        return;
      }
      this.dialog = true;
    },
    async printSale(type) {
      let x = await this.$confirm({
        title: "Print Sales",
        message: "Proceed with your request?",
        color: "primary",
        icon: "mdi-help-circle-outline",
      });
      if (!x) return;
      let formName;
      let formattedDate;
      let url;
      if (type == "perDay") {
        formName = "/print_per_day_sales/";
        formattedDate =
          this.printForm.year +
          "-" +
          this.printForm.month +
          "-" +
          this.printForm.day;
        url =
          this.default_server_url +
          formName +
          formattedDate +
          "/" +
          this.user.branch_id;
      } else if (type == "perMonthInvoice") {
        formName = "/print_per_month_invoice/";
        url =
          this.default_server_url +
          formName +
          this.printForm.month +
          "/" +
          this.printForm.year +
          "/" +
          this.user.branch_id;
      } else {
        formName = "/print_per_month_sales/";
        url =
          this.default_server_url +
          formName +
          this.printForm.month +
          "/" +
          this.printForm.year +
          "/" +
          this.user.branch_id;
      }

      window.open(url);
    },

    ...mapActions({
      get_import_batches: "importBatch/get_import_batches",
    }),
    changeSelection() {
      console.log(this.radioSelection);
    },
    submit() {
      let import_batch_id =
        this.form.radioSelection == "items" ? this.form.import_batch_id : 0;
      //   check if both date exists

      let url =
        this.default_server_url +
        "/print_item_sales/" +
        import_batch_id +
        "/" +
        this.form.radioSelection;
      window.open(url);
    },
    setFromDate(date) {
      this.form.fromDate = date;
    },
    setToDate(date) {
      this.form.toDate = date;
    },
  },

  created() {
    // generate days
    let x;
    for (x = 1; x <= 31; x++) {
      this.days.push(x);
    }
    let month = moment().month();
    let day = moment().date();
    let year = moment().year();
    this.printForm.month = month + 1;
    this.printForm.day = day;
    this.printForm.year = year;

    this.import_batches.unshift({
      id: "none",
      batch_description: "Print All",
    });
    if (this.import_batches.length < 2)
      this.get_import_batches().then(() => {});
  },
};
</script>

<style lang="scss" scoped></style>
